(() => {
  const BADGE_TEXT = 'Sofort verfügbar';

  const normalize = (value) => String(value || '').trim();

  function escapeCssAttr(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\n/g, '\\A ');
  }

  function escapeCssString(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\n/g, '\\A ');
  }

  function ensureBaseCss() {
    if (document.getElementById('instant-availability-base-css')) return;

    const style = document.createElement('style');
    style.id = 'instant-availability-base-css';
    style.textContent = `
      .option-selector[data-instant-selected="true"] .custom-select__btn .text-start::after {
        content: "${escapeCssString(BADGE_TEXT)}";
        pointer-events: none;
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        margin-left: 8px;

        padding: 2px 8px;
        border-radius: 999px;

        background: rgba(0,0,0,0.06);
        border: 1px solid rgba(0,0,0,0.12);

        font-size: 12px;
        font-weight: 500;
        line-height: 1.2;
        text-transform: none;
        letter-spacing: normal;
      }
    `;

    document.head.appendChild(style);
  }

  function getRulesStyle(uid) {
    const id = `instant-availability-rules-${uid}`;
    let style = document.getElementById(id);

    if (!style) {
      style = document.createElement('style');
      style.id = id;
      document.head.appendChild(style);
    }

    return style;
  }

  function getVariants(vp) {
    const script = vp.querySelector('script[data-instant-availability-json]');

    if (!script) {
      console.warn('[instant-availability] Missing data-instant-availability-json inside variant-picker');
      return [];
    }

    try {
      const data = JSON.parse(script.textContent);
      return Array.isArray(data?.variants) ? data.variants : [];
    } catch (error) {
      console.warn('[instant-availability] JSON parse failed', error);
      return [];
    }
  }

  function isInstantVariant(variant) {
    const qty = Number(variant.inventory_quantity);

    return (
      Boolean(variant.available) &&
      variant.inventory_management !== null &&
      variant.inventory_management !== '' &&
      !Number.isNaN(qty) &&
      qty > 0
    );
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant.options)) {
      return variant.options.map(normalize);
    }

    return [variant.option1, variant.option2, variant.option3]
      .filter((value) => value !== null && value !== undefined && value !== '')
      .map(normalize);
  }

  function getDropdownRoots(vp) {
    return Array.from(vp.querySelectorAll('.option-selector[data-selector-type="dropdown"]'));
  }

  function getSelectedValue(root) {
    const selectedOption = root.querySelector('.custom-select__option[aria-selected="true"][data-value]');

    if (selectedOption) {
      return normalize(selectedOption.getAttribute('data-value'));
    }

    return '';
  }

  function getDropdownValues(dropdownRoots) {
    return dropdownRoots.map((root) => {
      return new Set(
        Array.from(root.querySelectorAll('.custom-select__option.js-option[data-value]'))
          .map((item) => normalize(item.getAttribute('data-value')))
          .filter(Boolean)
      );
    });
  }

  function computeAllowedValues(variants, dropdownRoots, dropdownIndex) {
    const allowed = new Set();

    const dropdownValues = getDropdownValues(dropdownRoots);
    const selectedValues = dropdownRoots.map(getSelectedValue);

    variants.forEach((variant) => {
      if (!isInstantVariant(variant)) return;

      const options = getVariantOptions(variant);

      const dropdownToOptionIndex = dropdownValues.map((valuesSet) => {
        return options.findIndex((optionValue) => valuesSet.has(normalize(optionValue)));
      });

      const currentOptionIndex = dropdownToOptionIndex[dropdownIndex];

      if (currentOptionIndex === -1) return;

      // Kaskade: vorherige sichtbare Dropdowns müssen zur Variante passen.
      for (let i = 0; i < dropdownIndex; i += 1) {
        const selectedValue = selectedValues[i];
        const optionIndex = dropdownToOptionIndex[i];

        if (!selectedValue || optionIndex === -1) return;

        if (normalize(options[optionIndex]) !== selectedValue) {
          return;
        }
      }

      const value = normalize(options[currentOptionIndex]);

      if (value) {
        allowed.add(value);
      }
    });

    return allowed;
  }

  function setupIds(vp, dropdownRoots) {
    if (!vp.dataset.instantAvailabilityId) {
      vp.dataset.instantAvailabilityId = `ia-${Math.random().toString(36).slice(2, 10)}`;
    }

    dropdownRoots.forEach((root, index) => {
      if (root.getAttribute('data-instant-dropdown-index') !== String(index)) {
        root.setAttribute('data-instant-dropdown-index', String(index));
      }
    });

    return vp.dataset.instantAvailabilityId;
  }

  function setInstantSelected(root, active) {
    if (active) {
      if (root.getAttribute('data-instant-selected') !== 'true') {
        root.setAttribute('data-instant-selected', 'true');
      }
    } else if (root.hasAttribute('data-instant-selected')) {
      root.removeAttribute('data-instant-selected');
    }
  }

  function renderDynamicCss(uid, dropdownAllowedValues) {
    const style = getRulesStyle(uid);
    const rules = [];

    dropdownAllowedValues.forEach((allowedValues, dropdownIndex) => {
      if (!allowedValues) return;

      allowedValues.forEach((value) => {
        rules.push(`
          variant-picker[data-instant-availability-id="${escapeCssAttr(uid)}"]
          .option-selector[data-instant-dropdown-index="${dropdownIndex}"]
          .custom-select__option.js-option[data-value="${escapeCssAttr(value)}"]::after {
            content: "${escapeCssString(BADGE_TEXT)}";
            pointer-events: none;
            display: inline-flex;
            align-items: center;
            white-space: nowrap;
            margin-left: 10px;

            padding: 2px 8px;
            border-radius: 999px;

            background: rgba(0,0,0,0.06);
            border: 1px solid rgba(0,0,0,0.12);

            font-size: 12px;
            font-weight: 500;
            line-height: 1.2;
            text-transform: none;
            letter-spacing: normal;
          }
        `);
      });
    });

    style.textContent = rules.join('\n');
  }

  function enhance(vp) {
    const variants = getVariants(vp);
    const dropdownRoots = getDropdownRoots(vp);

    if (!dropdownRoots.length) return;

    const uid = setupIds(vp, dropdownRoots);

    if (!variants.length) {
      dropdownRoots.forEach((root) => setInstantSelected(root, false));
      renderDynamicCss(uid, []);
      return;
    }

    const selectedValues = dropdownRoots.map(getSelectedValue);
    const dropdownAllowedValues = [];

    dropdownRoots.forEach((root, index) => {
      let previousSelectionMissing = false;

      for (let i = 0; i < index; i += 1) {
        if (!selectedValues[i]) {
          previousSelectionMissing = true;
          break;
        }
      }

      if (previousSelectionMissing) {
        dropdownAllowedValues[index] = new Set();
        setInstantSelected(root, false);
        return;
      }

      const allowedValues = computeAllowedValues(variants, dropdownRoots, index);
      dropdownAllowedValues[index] = allowedValues;

      const selectedValue = getSelectedValue(root);
      setInstantSelected(root, Boolean(selectedValue && allowedValues.has(selectedValue)));
    });

    renderDynamicCss(uid, dropdownAllowedValues);
  }

  function init() {
    ensureBaseCss();

    const initialized = new WeakSet();

    function initVariantPicker(vp) {
      if (!vp || initialized.has(vp)) return;

      initialized.add(vp);

      let scheduled = false;
      let rendering = false;

      const run = () => {
        if (rendering) return;

        rendering = true;

        try {
          enhance(vp);
        } finally {
          rendering = false;
        }
      };

      const schedule = () => {
        if (scheduled) return;

        scheduled = true;

        requestAnimationFrame(() => {
          scheduled = false;
          run();
        });
      };

      const scheduleAfterSelect = () => {
        schedule();
        setTimeout(schedule, 100);
        setTimeout(schedule, 300);
        setTimeout(schedule, 650);
        setTimeout(schedule, 1200);
        setTimeout(schedule, 2000);
      };

      scheduleAfterSelect();

      vp.addEventListener('change', scheduleAfterSelect);
      vp.addEventListener('input', scheduleAfterSelect);

      vp.addEventListener('click', (event) => {
        if (
          event.target.closest('.custom-select__option') ||
          event.target.closest('.custom-select__btn') ||
          event.target.closest('.js-option')
        ) {
          scheduleAfterSelect();
        }
      });

      const observer = new MutationObserver(() => {
        if (rendering) return;
        scheduleAfterSelect();
      });

      observer.observe(vp, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'aria-selected',
          'class',
          'checked',
          'selected',
          'data-value',
          'data-variant-id'
        ]
      });
    }

    function scan() {
      document.querySelectorAll('variant-picker').forEach(initVariantPicker);
    }

    // Initial
    scan();

    // Nach Theme-Rebuilds erneut suchen
    document.addEventListener('change', () => {
      scan();
      setTimeout(scan, 300);
      setTimeout(scan, 1000);
    });

    document.addEventListener('click', (event) => {
      if (
        event.target.closest('variant-picker') ||
        event.target.closest('.custom-select__option') ||
        event.target.closest('.custom-select__btn') ||
        event.target.closest('.js-option')
      ) {
        scan();
        setTimeout(scan, 300);
        setTimeout(scan, 1000);
        setTimeout(scan, 2000);
      }
    });

    // Falls der ganze variant-picker oder Custom-Select ersetzt wird
    const documentObserver = new MutationObserver(() => {
      scan();
    });

    documentObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();